// pages/blog/index.tsx

'use client';

import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import BlogsLayout from '@/src/components/Blog/Layout';
const BlogsIndex = () => {
  const $ = _c(4);
  const router = useRouter();
  let t0;
  let t1;
  if ($[0] !== router) {
    t0 = () => {
      router.push("/blog/page/1");
    };
    t1 = [router];
    $[0] = router;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mt-34 min-h-screen items-center justify-center text-center font-normal md:mt-72">Loading...</div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
BlogsIndex.Layout = BlogsLayout;
export default BlogsIndex;